




import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class EnterpriseId extends Vue {
  
  @Prop({ default: '',  type: String}) enterpriseId!: string;

  extractEnterprise():string {
    let enterpriseList = this.enterpriseId.split('.');
    return enterpriseList.length === 1 ? enterpriseList[0] : enterpriseList.slice(1).join(' > ');
  }

  get formattedEnterprise(): string {
    return this.enterpriseId.split('.').pop() as string;
  }
}
